// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0c3b9c6e06a2e2b450f0","293":"7b0da5f19eb1e96e43a0","518":"b2bd0152b9098ef65b03","779":"6eddfd5e423f7293f2be"}[chunkId] + ".js";
};